import type { AppliedRichContentFlags } from '../schema/AppliedRichContentFlags';
import { getShouldShowRSVP } from 'mini-mail-list-store/lib/selectors/mailListDataPropertyGetter';
import { isSuggestedUnsubscribeItem } from 'mini-mail-suggested-unsubscribe-store/lib/utils/isSuggestedUnsubscribeItem';
import { useDisplayCustomisations } from '../components/VirtualizedListView/DisplayCustomisationsProvider';

export const useApplicableRichContentFlags = (rowId: string): AppliedRichContentFlags => {
    const { richContentFlags } = useDisplayCustomisations();
    const shouldShowRSVPUnit = richContentFlags.shouldShowRSVPUnit;
    const shouldShowSuggestedUnsubscribeUnit = richContentFlags.shouldShowSuggestedUnsubscribeUnit;
    return {
        showRSVPUnit: shouldShowRSVPUnit && getShouldShowRSVP(rowId),
        showSuggestedUnsubscribeUnit:
            shouldShowSuggestedUnsubscribeUnit && !!isSuggestedUnsubscribeItem(rowId),
    };
};
